import DropdownMenu from '../helpers/menu/dropdown';

function initDropdown() {
    const elem = document.querySelector('.js-dropdown');

    if (elem !== null) {
        // eslint-disable-next-line no-new
        new DropdownMenu(elem, {
            selectors: {
                dropdown: '.dropdown__container',
                root: 'html',
                closing: '.js-dropdown-close',
            },
            classes: {
                default: 'is-active',
                root: 'dropdown-active',
            },
        });
    }
}

initDropdown();
